import cx from "classnames";

import styles from "./Caption.module.scss";

interface Props {
  children: React.ReactNode,
  className?: string,
};

export function Caption({ children, className }: Props) {
  return (
    <p className={cx(styles.Caption, className)}>
      {children}
    </p>
  );
}

